export default function toClassName(string) {
    return string.replace(/\s+/g, '-').toLowerCase();
}
